import { useDispatch } from "react-redux";
import Info from "./Info";
import Person from "./Person";
import { addOpenDrawer } from "store/actions/appAction";
import { useNavigate } from "react-router-dom";

export interface FactorDetailProps {
  factor: any;
}

export default function FactorDetail({ factor }: FactorDetailProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handlePersonClick(personId: any) {
    if (personId) {
      dispatch(addOpenDrawer(false));
      navigate(`/reports/personalAccountCard?personId=${personId}`);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <div style={{ display: "flex", gap: 20 }}>
            <Info title="#" info={factor.accountingCode} />
            <Info title="عنوان  فاکتور" info={factor.title} />
          </div>
          {factor?.reference && <Info title="ارجاع" info={factor.reference} />}
          {factor?.Project && <Info title="پروژه" info={factor.Project.title} />}
          {factor?.Branch && <Info title="شعبه" info={factor.Branch.title} />}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          {factor?.Person && (
            <Info
              title="مشتری"
              info={
                <Person name={factor?.Person?.nickName} onClick={() => handlePersonClick(factor?.PersonId)} />
              }
            />
          )}
          {factor.Seller && (
            <Info
              title={"فروشنده"}
              info={
                <Person name={factor?.Seller?.nickName} onClick={() => handlePersonClick(factor.SellerId)} />
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
